import { AUTH } from "../constants/actionTypes"
import { createScore } from '../actions/scores'
import * as api from "../api/index.js"

export const signin = (formData, history) => async (dispatch) => {
    try {
        const { data } = await api.signIn(formData)
        dispatch({ type: AUTH, data })
        history.push("/")
    } catch (error) {
        console.log(error)
    }
}

export const signup = (formData, history) => async (dispatch) => {
    try {
        const { data } = await api.signUp(formData)
        dispatch({ type: AUTH, data })
        dispatch(createScore({ userId: formData.userId, userName: formData.firstName, email: formData.email, puntos: "1000", category: "Michi", media: "0", mediaCinco: "0" }))
        history.push("/")
    } catch (error) {
        console.log(error)
    }
}